import BaseExtension from '@/views/BaseExtension'
import { mapActions, mapState, mapGetters } from 'vuex'

export default BaseExtension.extend({
    computed: {
        ...mapState('patients', {
            patient: state => state.current,
        }),
        ...mapState('schedule', {
            consultation: state => state.current.consultation,
        }),
        ...mapState('decursus', {
            decursus: state => state.current,
        })
    },
    watch: {
        patient: {
            immediate: true,
            async handler(val) {
                if (val) {
                    await this.loadForPatient(val)
                }
            }
        },
        consultation: {
            immediate: true,
            async handler(val) {
                if (val) {
                    await this.loadForConsultation(val)
                }
            }
        },
        decursus: {
            immediate: true,
            async handler(val) {
                if (val) {
                    await this.loadForDecursus(val)
                }
            }
        }
    },
    methods: {
        async loadForPatient(patient) {},
        async loadForConsultation(consultation) {},
        async loadForEpisode(episode) {},
        async loadForDecursus(decursus) {},
    }
})